import { ILocationPerformance } from './initialState';
import { ILocationPerformanceReportListItem, PaginationResponse } from '@ready/dashboardv2api.contracts';
import { IPagedResponse } from '@ready/table.core';
import { ILocation } from '../../../services/types/ILocation.type';

export const fetchLocationPerformanceReducers = {
  pending: (state: ILocationPerformance) => {
    state.loading.list = true;
  },
  fulfilled: (
    state: ILocationPerformance,
    action: { payload: PaginationResponse<ILocationPerformanceReportListItem> }
  ) => {
    const { items, total, limit, start, length } = action.payload;
    state.loading.list = false;
    state.items = items;
    state.pagination = { total, limit, start, length };
  },
  rejected: (state: ILocationPerformance) => {
    state.loading.list = false;
    state.errors.list = 'Unable to retrieve Location Performance list.';
  },
};

export const exportLocationPerformanceReducers = {
  pending: (state: ILocationPerformance) => {
    state.loading.export = true;
  },
  fulfilled: (state: ILocationPerformance) => {
    state.loading.export = false;
  },
  rejected: (state: ILocationPerformance) => {
    state.loading.export = false;
  },
};

export const fetchPermittedLocationsReducers = {
  pending: (state: ILocationPerformance) => {
    state.loading.permittedLocations = true;
  },
  fulfilled: (state: ILocationPerformance, action: { payload: IPagedResponse<ILocation> }) => {
    state.loading.permittedLocations = false;
    state.permittedLocations = action.payload;
  },
  rejected: (state: ILocationPerformance) => {
    state.loading.permittedLocations = false;
  },
};
